import React from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { SafeAreaProvider } from 'react-native-safe-area-context';
import { HydrationBoundary } from '@tanstack/react-query';
import SSRProvider from 'react-bootstrap/SSRProvider';
import { useSettingsStore } from '@annunciate/core';
import { QueryContextProvider } from '@annunciate/query';
import { DiscussionContext, } from '@annunciate/ui';
import { DiscussionChannelAware } from '@annunciate/comments';
import Config from '@annunciate/core/dist/utils/config';
import { AuthProvider } from '@annunciate/web/dist/providers/AuthProvider';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../styles.css';
import { ThemedApp } from './ThemedApp';
import { NavigationContextProvider } from '../context';
export function App({ theme = {}, client, dehydratedState, children, onNavigate, }) {
    useSettingsStore.getState().setDefaultThemeMode(theme.mode);
    const initialSafeAreaInsets = {
        top: 0,
        right: 0,
        left: 0,
        bottom: 0,
    };
    return (React.createElement(SSRProvider, null,
        React.createElement(QueryContextProvider, { endpoint: Config.API_HOST || '' },
            React.createElement(QueryClientProvider, { client: client },
                React.createElement(HydrationBoundary, { state: dehydratedState },
                    React.createElement(NavigationContextProvider, { onNavigate: onNavigate },
                        React.createElement(AuthProvider, null,
                            React.createElement(DiscussionContext.Provider, { value: DiscussionChannelAware },
                                React.createElement(SafeAreaProvider, { initialSafeAreaInsets: initialSafeAreaInsets },
                                    React.createElement(ThemedApp, { theme: theme }, children))))))))));
}
export default App;
//# sourceMappingURL=App.js.map